const SLUG = /^[a-z0-9-]+$/;

// CAPITULO[text, book, chapter(, anchor)] and LIVRO[text, book] as a site path and its link
// text; null for any other shape (a comma in the text, a fifth part), which stays a tag. So does
// text with Markdown or HTML characters: the tag escapes it after kramdown, a link would not.
export function siteLink(tag: string, args: string): { text: string; href: string } | null {
	const [text, ...slugs] = args.split(",").map((part) => part.trim());
	if (!text || /[[\]*_`\\<>&]/.test(text) || !slugs.every((slug) => SLUG.test(slug))) return null;
	if (tag === "LIVRO" && slugs.length === 1) return { text, href: `/livros/${slugs[0]}` };
	if (tag === "CAPITULO" && (slugs.length === 2 || slugs.length === 3)) {
		return { text, href: `/livros/${slugs[0]}/capitulos/${slugs[1]}${slugs[2] ? `#${slugs[2]}` : ""}` };
	}
	return null;
}

// Inside a raw HTML table cell Markdown does not apply, so the link is an <a>.
export function linksToAnchors(html: string): string {
	return html.replace(/(CAPITULO|LIVRO)\[([^\]\n]*)\]/g, (tag, name, args) => {
		const link = siteLink(name, args);
		return link ? `<a href="${link.href}">${link.text}</a>` : tag;
	});
}
